import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";

export type DemandSummaryFilters = {
  asOfDate: string;
  teamId?: string;
  userId?: string;
};
export type DemandSummaryGroup = {
  teamId: string | null;
  label: string;
  priorDay: number;
  weekToDate: number;
  monthToDate: number;
  priorMonth: number;
  yearToDate: number;
};
export type DemandSummaryMonthTeam = {
  teamId: string | null;
  label: string;
  count: number;
};
export type DemandSummaryMonth = {
  month: string;
  count: number;
  teams?: DemandSummaryMonthTeam[];
};
export type DemandSummaryOption = { id: string; label: string };
export type DemandSummaryResponse = {
  data: {
    groups: DemandSummaryGroup[];
    totals: DemandSummaryGroup;
    months: DemandSummaryMonth[];
    teams: DemandSummaryOption[];
    users: DemandSummaryOption[];
    freshness: {
      oldestProjectionAt: string | null;
      pendingMatters: number;
      missingMatters: number;
      ready: boolean;
    };
  };
};
export async function retrieveDemandSummary(
  filters: DemandSummaryFilters,
  signal?: AbortSignal,
) {
  const response =
    await authenticatedFastApiAxiosInstance.post<DemandSummaryResponse>(
      "reports/v2/demand-summary/query",
      filters,
      { signal },
    );
  return response.data;
}
